// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","fiveRecipesContainer":"Gf5d3ed","fiveRecipesText":"G964e3f","leftArrow":"G85e70d"};